import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

textarea {
  resize: none;
}`],
})
export class PageDashboardComponent implements OnInit {
    public loading: boolean = true;
    public activePanel: string = 'intake';
    public activePattern: string = '비위기허형 소화불량';
    public applyStatus: string = 'draft';
    public aiWritingPaused: boolean = false;
    public finalEvidenceId: string = 'EVID-20260627-001';
    public detailPanel: string | null = null;
    public draggedPattern: any = null;
    public activeSoapField: string | null = null;
    public safetyOverrideReason: string = '';
    public dialogueDraft: string = '';
    public activeVitalQuestion: any = null;
    public voiceDemoRunning: boolean = true;
    public caseInfo: any = {
        title: '기능성 소화불량 초진 케이스',
        patientLabel: '39세 여성 · 초진',
        chief: '식후 더부룩함과 조기포만감',
        mode: '진료 중',
        nextAction: '위험 신호 확인',
        dataset: '소화불량 표준차트'
    };
    public caseFlow: any[] = [
        { step: '환자 발화', status: '완료', detail: '주소증 수집' },
        { step: '주소증 감지', status: '완료', detail: '소화불량 91%' },
        { step: '표준 차트', status: '진행', detail: '9/12 항목 확인' },
        { step: '검진 비교', status: '완료', detail: '핵심 지표 반영' },
        { step: '변증·SOAP', status: '생성됨', detail: '비위기허 우선' }
    ];
    public voiceStatus: any[] = [
        { label: '마이크', value: '수신 중', note: '음성 입력 대기', status: '수신 중' },
        { label: '화자 분리', value: '환자/한의사', note: '최근 발화: 환자', status: '분석 중' },
        { label: '원문 저장', value: '자동저장', note: '원문과 보정 후보 보존', status: '저장됨' }
    ];
    public voiceSegments: any[] = [
        { time: '09:43:18', speaker: '환자', raw: '먹으면 금방 배가 차고 더부룩해요', corrected: '먹으면 금방 배가 차고 더부룩해요.', confidence: 95, status: '반영됨', mapped: '조기포만감 / 식후포만감' },
        { time: '09:43:06', speaker: '한의사', raw: '체중이 줄거나 검은 변을 본 적은 있나요', corrected: '체중이 줄거나 검은 변을 본 적은 있나요?', confidence: 97, status: '저장됨', mapped: '위험 신호 확인' },
        { time: '09:42:51', speaker: '환자', raw: '위내시경은 작년에 했고 큰 이상은 없었어요', corrected: '위내시경은 작년에 했고 큰 이상은 없었어요.', confidence: 93, status: '보정됨', mapped: '검진 핵심 항목' }
    ];
    public aiPipeline: any[] = [
        { step: '주소증 추론', status: '완료', progress: 100, output: '소화불량 91%, 역류 의심 42%, 복통 28%' },
        { step: '표준 차트 매핑', status: '진행', progress: 80, output: '식후포만감, 조기포만감, 명치 답답함 확인' },
        { step: '검진 지표 비교', status: '완료', progress: 100, output: 'BMI, 혈압, 혈당, 간수치 비교' },
        { step: '변증 후보 산출', status: '완료', progress: 100, output: '비위기허, 간위불화, 담습중조 후보 유지' },
        { step: 'SOAP 초안 생성', status: '생성됨', progress: 92, output: '소화불량 차트 항목과 대화 기반 초안 생성' }
    ];
    public aiDraftSignals: any[] = [
        { label: 'SOAP', value: '발화 반영', note: 'S/O/A/P 갱신' },
        { label: '변증', value: '비위기허 우선', note: '간위불화·담습중조 감별 유지' },
        { label: '처방', value: '검토 대기', note: '식욕, 대변, 열감 확인 후 확정' }
    ];

    public panels: any[] = [
        { key: 'intake', label: '예진', subtitle: '대기실' },
        { key: 'clinic', label: '진료', subtitle: '진료실' },
        { key: 'evidence', label: '기록', subtitle: '근거문서' },
        { key: 'revisit', label: '재진', subtitle: '시계열' }
    ];

    public stats: any[] = [];
    public summary: any = {
        patient: 'PSEUDO-FD-042',
        age: '39세',
        sex: '여',
        chief: '소화불량',
        secondary: '식후 더부룩함·조기포만감',
        encounter: '초진',
        started: '09:42',
        evidence_id: 'EVID-20260627-FD001'
    };

    public chiefCandidates: any[] = [
        { name: '소화불량', confidence: 91, note: '식후포만감 + 조기포만감 반복' },
        { name: '기능성 소화불량', confidence: 78, note: '위내시경 특이소견 없음, 만성 경과' },
        { name: '역류/상복부 불편감', confidence: 42, note: '명치 답답함 동반, 쓰림은 약함' }
    ];

    public precheck: any = {
        input: '밥을 조금만 먹어도 금방 배가 차고 식후에 명치가 답답해요. 3개월 넘게 반복되고 스트레스 받으면 더 심해집니다.',
        summary: '대기실 예진에서 소화불량을 주호소로, 식후포만감과 조기포만감을 핵심 증상으로 추론했습니다.',
        completed: 9,
        total: 12,
        status: '진료실 진행 중'
    };

    public intakeFlow: any[] = [
        { step: '접수', owner: '스태프', status: '완료', note: '태블릿 예진 안내 및 환자 확인' },
        { step: '자연어 주소증', owner: '환자', status: '완료', note: '식후 더부룩함, 조기포만감, 명치 답답함 입력' },
        { step: '20종 주소증 분류', owner: '진료지원', status: '완료', note: '소화불량 91%, 기능성 소화불량 78%' },
        { step: '표준 차트 로딩', owner: '진료지원', status: '진행', note: '소화불량 표준 항목 12개 중 9개 확인' },
        { step: '진료실 인계', owner: '스태프', status: '대기', note: '체중감소, 흑변, 연하곤란 확인 필요' }
    ];

    public patientQuestions: any[] = [
        { category: '핵심', patient: '식후 더부룩함이 어느 정도 지속되나요?', clinical: '식후포만감', answered: true, answer: '거의 매 식후 2~3시간' },
        { category: '핵심', patient: '조금만 먹어도 금방 배가 차나요?', clinical: '조기포만감', answered: true, answer: '반 공기 정도 먹으면 포만감' },
        { category: '상복부', patient: '명치 통증이나 쓰림이 동반되나요?', clinical: '상복부 통증/쓰림', answered: true, answer: '답답함 위주, 쓰림은 가끔' },
        { category: '동반', patient: '트림, 오심, 구토가 있나요?', clinical: '동반 소화기 증상', answered: true, answer: '트림 잦음, 구토 없음' },
        { category: '안전', patient: '이유 없이 체중이 줄었나요?', clinical: '체중감소', answered: false, answer: '' },
        { category: '안전', patient: '검은 변, 피 섞인 변, 빈혈 소견을 들은 적이 있나요?', clinical: '흑변/출혈', answered: false, answer: '' },
        { category: '검진', patient: '최근 위내시경이나 건강검진 결과가 있나요?', clinical: '검진 핵심 항목', answered: true, answer: '작년 위내시경 특이소견 없음' }
    ];

    public intakeHandoff: any[] = [
        { label: '예진 요약을 진료실 1단에 표시', done: true },
        { label: '소화불량 표준 차트 항목을 자동 로딩', done: true },
        { label: '건강검진 핵심 항목을 비교 그래프에 연결', done: true },
        { label: '체중감소·흑변 미확인 항목을 최종 확인에 연결', done: true }
    ];

    public intakeOutputs: any[] = [
        { label: '예진 요약', value: '식후포만감, 조기포만감, 명치 답답함' },
        { label: '주소증 후보', value: '소화불량 / 기능성 소화불량 / 역류 의심' },
        { label: '미확인 필수 항목', value: '체중감소, 흑변/토혈, 진행성 연하곤란' },
        { label: '진료실 추천 질문', value: '식사량, 스트레스 악화, 대변, 위내시경 결과' }
    ];

    public transcript: any[] = [
        { time: '09:42:34', speaker: '환자', text: '밥을 조금만 먹어도 금방 배가 차고 식후에 명치가 답답해요.', tag: '주소증 감지' },
        { time: '09:42:48', speaker: '한의사', text: '이런 증상이 얼마나 반복됐나요?', tag: '발병 기간 문진' },
        { time: '09:42:55', speaker: '환자', text: '3개월은 넘은 것 같고, 스트레스 받으면 더 심해요.', tag: '만성 경과/악화 요인' },
        { time: '09:43:06', speaker: '한의사', text: '체중이 줄거나 검은 변을 본 적은 있나요?', tag: '위험 신호 확인' },
        { time: '09:43:18', speaker: '환자', text: '작년에 위내시경은 괜찮다고 들었고, 기름진 음식 먹으면 더 답답해요.', tag: '검진 정보 반영' }
    ];

    public checklist: any[] = [
        { label: '식후포만감', status: '확인됨', checked: true, required: true, risk: false },
        { label: '조기포만감', status: '확인됨', checked: true, required: true, risk: false },
        { label: '상복부 통증/쓰림', status: '일부 확인', checked: true, required: true, risk: false },
        { label: '증상 기간 3개월 이상', status: '확인됨', checked: true, required: true, risk: false },
        { label: '체중감소', status: '미확인', checked: false, required: true, risk: true },
        { label: '흑변/토혈/빈혈', status: '미확인', checked: false, required: true, risk: true },
        { label: '진행성 연하곤란', status: '부인', checked: true, required: true, risk: true },
        { label: '위내시경/검진 결과', status: '확인됨', checked: true, required: false, risk: false }
    ];

    public patternCandidates: any[] = [
        {
            name: '비위기허형 소화불량',
            confidence: 72,
            rank: 1,
            selected: true,
            rejected: false,
            direction: '건비익기·화위 중심',
            evidence: ['식후포만감', '조기포만감', '식사량 감소', '피로 시 악화']
        },
        {
            name: '간위불화형 소화불량',
            confidence: 58,
            rank: 2,
            selected: false,
            rejected: false,
            direction: '소간이기·화위 감별',
            evidence: ['스트레스 악화', '명치 답답함', '트림 잦음', '수면/긴장도 확인 필요']
        },
        {
            name: '담습중조형 소화불량',
            confidence: 41,
            rank: 3,
            selected: false,
            rejected: false,
            direction: '화담제습 감별',
            evidence: ['더부룩함', '체중/BMI 경도 증가', '담백한 식사 반응 확인 필요']
        }
    ];

    public soap: any = {
        S: '3개월 이상 반복되는 식후 더부룩함과 조기포만감. 반 공기 정도 섭취 후 포만감이 오며 스트레스 시 악화. 트림 잦고 구토는 부인. 작년 위내시경 특이소견 없음.',
        O: 'BMI 24.8, 혈압 124/78, 공복혈당 101mg/dL. 복부 압통은 경미하며 반발통 없음. 설진/맥진 소견 입력 대기.',
        A: '소화불량. 기능성 소화불량 양상 우선 고려. 비위기허형 소화불량을 1순위로 보며, 스트레스 악화와 명치 답답함으로 간위불화 감별 필요. 체중감소, 흑변/토혈 등 위험 신호 최종 확인 필요.',
        P: '식사량과 식후 증상 기록을 안내하고, 건비익기·화위 중심 치료 방향을 검토. 체중감소, 흑변, 진행성 연하곤란을 확인한 뒤 처방 후보와 생활지도를 최종 확정.'
    };

    public prescription: any[] = [
        { name: '건비익기·화위 계열', basis: '조기포만감, 식후포만감, 식사량 감소', status: '1순위', caution: '변비/설사 양상과 열감 여부 확인' },
        { name: '소간이기 가감', basis: '스트레스 시 악화, 명치 답답함, 트림', status: '감별', caution: '불면, 흉협부 긴장, 월경 관련 악화 확인' },
        { name: '화담제습 보조', basis: '더부룩함 지속, BMI 경도 증가, 무거운 느낌', status: '보조', caution: '구갈, 열감, 식욕저하가 심하면 신중' }
    ];

    public formulaCandidates: any[] = [
        { formula: '비위기허 방제 후보', method: '건비익기', reason: '조기포만감과 식사량 감소가 뚜렷함', caution: '복부팽만과 대변 양상 확인 후 용량 조절', selected: true },
        { formula: '간위불화 가감 후보', method: '소간이기', reason: '스트레스 악화와 명치 답답함 동반', caution: '불면, 두근거림, 월경 관련 악화 확인', selected: false },
        { formula: '담습중조 보조 후보', method: '화담제습', reason: '더부룩함과 무거운 느낌이 지속됨', caution: '열감과 구갈이 있으면 과도한 온조 약재 신중', selected: false }
    ];

    public herbAdjustments: any[] = [
        { herb: '건비 약재군', role: '군/신', change: '기본 유지', rationale: '식후포만감과 식사량 감소를 중심으로 반영' },
        { herb: '이기 약재군', role: '신/좌', change: '스트레스 악화 시 가감', rationale: '명치 답답함과 트림이 간위불화 감별 근거' },
        { herb: '소도/화담 약재군', role: '좌/사', change: '식체감 확인 후 추가', rationale: '더부룩함과 무거운 느낌이 지속될 때 보조' }
    ];

    public advancedAnalyses: any[] = [
        { name: '설진 분석', priority: '필요 시', status: '대기', result: '이미지 입력 시 설질, 설태, 치흔 분석' },
        { name: '동작 분석', priority: '필요 시', status: '대기', result: '보행, 굴신, 요추 가동범위 분석' },
        { name: '문헌 근거 검색', priority: '근거 확인', status: '대기', result: '교과서/가이드 기반 근거 검색' },
        { name: '논문 근거 검색', priority: '근거 확인', status: '대기', result: '질환, 방제, 약재 관련 논문 근거 검색' },
        { name: '약재 가감 검토', priority: '처방 검토', status: '대기', result: '군신좌사 구조와 용량 조절 근거 제안' },
        { name: '성분·경로 분석', priority: '추가 검토', status: '대기', result: '성분-표적-경로 기반 처방 해석' }
    ];

    public auditLogs: any[] = [
        { time: '09:42:21', type: '예진', text: '환자 자연어 예진 원본 저장' },
        { time: '09:42:35', type: '주소증', text: '소화불량 템플릿 자동 로딩' },
        { time: '09:43:18', type: '음성인식', text: '조기포만감 발화가 표준 차트 항목에 자동 반영' },
        { time: '09:44:02', type: '변증 후보', text: '비위기허/간위불화/담습중조 후보 생성' }
    ];

    public timeline: any[] = [
        { visit: '1회차', nrs: 7, qi: 72, kidney: 58, note: '식후포만감과 조기포만감 중심' },
        { visit: '2회차 예측', nrs: 4, qi: 55, kidney: 48, note: '식사량과 식후 불편감 변화 추적' }
    ];

    public revisitComparison: any[] = [
        { item: '식후포만감 VAS', first: '7', current: '4', trend: '호전' },
        { item: '비위기허 확신도', first: '72%', current: '55%', trend: '감소' },
        { item: '간위불화 확신도', first: '58%', current: '48%', trend: '감소' },
        { item: '식사량', first: '반 공기', current: '2/3 공기', trend: '호전' },
        { item: '트림/명치 답답함', first: '잦음', current: '감소', trend: '관찰' },
        { item: '처방 방향', first: '건비익기 중심', current: '이기 가감 감량 검토', trend: '가감' }
    ];

    public storageFlow: any[] = [
        '예진 원본',
        '진료실 음성인식 원문',
        '음성인식 후보',
        '주소증 추론 로그',
        '문진 체크 및 누락 이력',
        '위험 신호 확인 여부',
        '변증 후보 변화',
        '한의사 조정',
        '처방 후보 및 가감 로그',
        '최종 SOAP/처방',
        '근거문서 ID',
        '원내 백업'
    ];

    public evidenceArtifacts: any[] = [
        { name: '예진 원본', state: '저장됨', source: '대기실 태블릿' },
        { name: '음성인식 원문', state: '저장됨', source: '진료실 마이크' },
        { name: '음성인식 후보', state: '저장됨', source: '음성인식 보정' },
        { name: '주소증 추론 로그', state: '저장됨', source: '진료 가이드' },
        { name: '표준 문진 체크 상태', state: '갱신 중', source: '진료 가이드' },
        { name: '변증 순위 변경 로그', state: '대기', source: '한의사 조작' },
        { name: '처방 가감 변경 로그', state: '대기', source: '처방 초안' },
        { name: '최종 SOAP/처방', state: '최종 반영 대기', source: 'EMR 초안' }
    ];

    public sttCandidates: any[] = [
        { phrase: '소화가 잘 안 돼요', selected: true, candidates: ['소아과 잘 안 돼요', '속이 확 자꾸 쓰려요', '소화가 잘 안 돼요'], basis: '예진 부증상과 한의학 용어 사전으로 보정' },
        { phrase: '조금만 먹어도 배가 차요', selected: true, candidates: ['조금만 먹어도 배가 차요', '조금만 먹어도 배가 차요?', '조금만 먹어도 배가 자요'], basis: '소화불량 템플릿의 조기포만감 문맥과 일치' }
    ];

    public terminology: any[] = [
        { term: '비위기허', type: '변증', note: '식후포만감, 식사량 감소, 피로감과 연결' },
        { term: '간위불화', type: '변증', note: '스트레스 악화, 명치 답답함, 트림과 연결' },
        { term: '건비익기', type: '치법', note: '비위 기능 회복과 식사량 개선 방향으로 처방 후보에 반영' },
        { term: '소간이기', type: '치법', note: '긴장·스트레스 관련 소화불량 감별 시 가감 방향으로 반영' }
    ];

    public xaiEvidence: any[] = [
        { source: '환자 발화', evidence: '조금만 먹어도 금방 배가 참', effect: '조기포만감 핵심 항목 확인' },
        { source: '환자 발화', evidence: '식후 명치가 답답함', effect: '식후포만감 및 상복부 불편감 반영' },
        { source: '문진', evidence: '스트레스 시 악화', effect: '간위불화 가능성 증가' },
        { source: '검진', evidence: '작년 위내시경 특이소견 없음', effect: '기능성 소화불량 가설 보강' },
        { source: '안전 문진', evidence: '흑변/토혈 미확인', effect: '최종 반영 전 위험 신호 확인 필요' },
        { source: '검진 지표', evidence: '공복혈당 101mg/dL', effect: '대사 지표 상담 참고' },
        { source: '한의사 입력', evidence: '설진/맥진 입력 대기', effect: '비위기허와 담습 감별 보류' }
    ];

    public differentials: any[] = [
        { name: '기능성 소화불량', status: '가능성 높음', reason: '만성 반복 증상, 위내시경 특이소견 없음, 식후포만감/조기포만감 우세' },
        { name: '위식도역류/상복부 통증 증후군', status: '감별 유지', reason: '명치 답답함과 쓰림이 일부 동반되어 확인 필요' },
        { name: '소화성 궤양/종양성 질환', status: '위험 신호 배제 필요', reason: '체중감소, 흑변/토혈, 진행성 연하곤란 최종 확인 필요' }
    ];

    public redFlagCatalog: any[] = [
        { complaint: '소화불량', item: '원인 불명 체중감소', status: '미확인', severity: 'high' },
        { complaint: '소화불량', item: '흑변/토혈/빈혈 소견', status: '미확인', severity: 'high' },
        { complaint: '소화불량', item: '진행성 연하곤란 또는 지속 구토', status: '부인', severity: 'high' },
        { complaint: '소화불량', item: '고령 초발, 암 가족력, 야간 통증', status: '일부 확인', severity: 'medium' },
        { complaint: '두통', item: '갑작스런 극심한 두통/신경학적 결손', status: '주소증 아님', severity: 'medium' },
        { complaint: '흉통', item: '호흡곤란/식은땀/실신', status: '주소증 아님', severity: 'medium' },
        { complaint: '복통', item: '복막자극/고열/혈변/지속 구토', status: '주소증 아님', severity: 'medium' }
    ];

    public rewriteHistory: any[] = [
        { time: '09:44:10', action: '초안 생성', text: '비위기허형 소화불량 중심 Assessment/Plan 생성' },
        { time: '09:44:31', action: '감별 유지', text: '간위불화와 담습중조 후보를 감별 가설로 보존' }
    ];

    public ghostDrafts: any[] = [
        {
            pattern: '비위기허형 소화불량',
            keptAt: '09:44:31',
            reason: '간위불화 감별 중에도 초기 1순위 근거 보존',
            A: '소화불량. 식후포만감과 조기포만감을 근거로 비위기허형 소화불량 우선 고려.',
            P: '건비익기·화위 중심 치료 방향을 검토하고 위험 신호 배제를 병행.'
        }
    ];

    public architecture: any[] = [
        { layer: '원내 처리 서버', role: '음성인식, 개인정보 필터링, 위험 신호 감지, 기본 SOAP 초안' },
        { layer: '원내 로컬 DB', role: '예진, 음성인식 원문, SOAP, 처방, 추천/수정 이력 저장' },
        { layer: '원내 백업 저장소', role: '원본 음성, 근거문서, 진료 세션 비동기 백업' },
        { layer: '외부 추가 분석', role: '비식별 데이터 기반 추가 변증 검토, 문헌 근거 검색, 복잡 생성' }
    ];

    public standardComplaints: string[] = [
        '요통', '두통', '경항통', '견비통', '슬통',
        '소화불량', '복통', '흉통', '불면', '피로',
        '어지럼', '비염', '기침', '월경통', '갱년기',
        '안면마비', '중풍 후유증', '소아 성장', '비만', '냉증'
    ];

    public standardQuestions: any[] = [
        { category: '소화불량', question: '식후포만감, 조기포만감, 상복부 통증/쓰림 중 주된 증상은 무엇인가요?', status: '확인됨' },
        { category: '소화불량', question: '증상이 3개월 이상 반복되었고 최근 6개월 내 시작되었나요?', status: '확인됨' },
        { category: '소화불량', question: '식사량, 식사 속도, 기름진 음식, 카페인과의 관련이 있나요?', status: '일부 확인' },
        { category: '소화불량', question: '트림, 오심, 구토, 복부팽만, 대변 변화가 동반되나요?', status: '일부 확인' },
        { category: '검진', question: '위내시경, 복부초음파, 건강검진 핵심 지표 결과가 있나요?', status: '확인됨' },
        { category: '안전', question: '체중감소, 흑변/토혈, 빈혈, 진행성 연하곤란이 있나요?', status: '미확인' },
        { category: '한의 생체지표', question: '식욕·소화, 대소변, 수면, 한열·땀, 구갈, 설진·맥진을 확인했나요?', status: '일부 확인' }
    ];

    public koreanMedicineVitals: any[] = [
        { label: '식욕·소화', signal: '비위 기능', question: '평소 식욕, 식사량, 식후 더부룩함은 어떠세요?', value: '식욕 저하, 식후 답답함', status: '확인됨' },
        { label: '대변·소변', signal: '습담/열상', question: '대변 횟수와 형태, 소변 색이나 야간뇨 변화가 있나요?', value: '대변 변화 확인 필요', status: '대기' },
        { label: '수면·피로', signal: '기혈 회복', question: '수면 시간, 중간 각성, 오후 피로감은 어느 정도인가요?', value: '오후 피로', status: '일부 확인' },
        { label: '한열·땀', signal: '한열 편차', question: '추위를 타거나 열감, 식은땀, 땀 양 변화가 있나요?', value: '추위/열감 확인 필요', status: '대기' },
        { label: '구갈·음수', signal: '진액 상태', question: '입마름, 물 마시는 양, 찬물이나 따뜻한 물 선호가 있나요?', value: '입마름 확인 필요', status: '대기' },
        { label: '설진·맥진', signal: '한의 소견', question: '혀 상태와 맥진 소견을 입력해 변증 근거에 반영할까요?', value: '설진/맥진 입력 대기', status: '대기' }
    ];

    public chartFields: any[] = [
        { group: '핵심 증상', label: '식후포만감', value: '매 식후 2~3시간', status: '확인됨', required: true, risk: false },
        { group: '핵심 증상', label: '조기포만감', value: '반 공기 섭취 후 포만', status: '확인됨', required: true, risk: false },
        { group: '핵심 증상', label: '상복부 통증/쓰림', value: '답답함 우세, 쓰림 간헐', status: '일부 확인', required: true, risk: false },
        { group: '경과', label: '증상 기간', value: '3개월 이상', status: '확인됨', required: true, risk: false },
        { group: '악화 요인', label: '스트레스/식습관', value: '스트레스 시 악화', status: '확인됨', required: true, risk: false },
        { group: '동반 증상', label: '트림/오심/구토', value: '트림 잦음, 구토 없음', status: '확인됨', required: false, risk: false },
        { group: '안전', label: '체중감소', value: '진료실 재확인', status: '미확인', required: true, risk: true },
        { group: '안전', label: '흑변/토혈/빈혈', value: '진료실 재확인', status: '미확인', required: true, risk: true },
        { group: '안전', label: '진행성 연하곤란', value: '부인', status: '부인', required: true, risk: true },
        { group: '검진', label: '위내시경', value: '2025년 특이소견 없음', status: '확인됨', required: false, risk: false },
        { group: '한의', label: '식욕/피로', value: '식욕 저하, 오후 피로', status: '확인됨', required: false, risk: false },
        { group: '한의', label: '설진/맥진', value: '입력 대기', status: '대기', required: false, risk: false }
    ];

    public screeningMetrics: any[] = [
        { label: 'BMI', value: 24.8, unit: 'kg/m²', range: '18.5-22.9', percentile: 68, status: '주의', note: '표준 범위보다 약간 높음' },
        { label: '혈압', value: 124, unit: 'mmHg', range: '<120', percentile: 58, status: '주의', note: '수축기 기준 경계 영역' },
        { label: '공복혈당', value: 101, unit: 'mg/dL', range: '70-99', percentile: 62, status: '주의', note: '식습관 상담 참고' },
        { label: 'AST/ALT', value: 24, unit: 'U/L', range: '<40', percentile: 35, status: '정상', note: '간기능 기준 범위' },
        { label: '위내시경', value: '특이소견 없음', unit: '', range: '없음', percentile: 12, status: '정상', note: '기능성 가설 보강' }
    ];

    public symptomScoreTrend: any[] = [
        { label: '식후포만감', baseline: 7, current: 7, target: 3, percentile: 76, note: '동일 주소증 표준 비교 상위권' },
        { label: '조기포만감', baseline: 8, current: 8, target: 4, percentile: 82, note: '주요 추적 지표' },
        { label: '명치 답답함', baseline: 6, current: 6, target: 3, percentile: 64, note: '간위불화 감별 근거' }
    ];

    public distributionReference: any = {
        label: '소화불량 표준 문진 총점',
        shortLabel: 'FD-20',
        sample: '동일 주소증 초진 참조군 1,284례',
        mean: 18.5,
        sd: 7,
        max: 40
    };

    public questionnaireScoreItems: any[] = [
        { label: '식후포만감', field: '식후포만감', score: 7, max: 10 },
        { label: '조기포만감', field: '조기포만감', score: 8, max: 10 },
        { label: '명치 답답함', field: '상복부 통증/쓰림', score: 6, max: 10 },
        { label: '스트레스 악화', field: '스트레스/식습관', score: 5, max: 10 }
    ];

    public recommendedQuestions: string[] = [
        '최근 3개월 동안 체중이 의도치 않게 줄었나요?',
        '검은 변이나 피 섞인 구토, 빈혈 소견을 들은 적이 있나요?',
        '삼키기 어렵거나 음식이 걸리는 느낌이 점점 심해지나요?',
        '스트레스가 심한 날 명치 답답함이나 트림이 더 늘어나나요?'
    ];

    public quantitativeSignals: any[] = [
        { label: '식후포만감 VAS', value: '7/10', note: '재진 비교 기준값' },
        { label: '차트 확인률', value: '80%', note: '필수 안전항목 제외 시 즉시 갱신' },
        { label: '변증 우선순위', value: '72 / 58 / 41', note: '절대 확률이 아닌 상대 가설' },
        { label: '표준 백분위', value: '82p', note: '동일 주소증 증상 점수 비교' },
        { label: '재진 목표', value: 'VAS -3', note: '1~2주 후 식후포만감 변화 추적' }
    ];

    public applyChecklist: any[] = [
        { label: '한의사 검토 완료', done: false },
        { label: '필수 문진 확인 또는 미확인 사유 기록', done: false },
        { label: '위험 신호 확인', done: false },
        { label: '처방 후보와 금기/주의 검토', done: false },
        { label: '근거문서 ID 연결', done: true }
    ];

    public governancePolicies: any[] = [
        { title: '비식별 전송', note: '외부 추가 분석에는 환자 식별자, 원문 음성, 직접 식별 정보 없이 임상 메타데이터만 전달' },
        { title: '원내 보존', note: '예진 원본, 음성인식 원문, 최종 SOAP, 처방, 근거문서는 로컬 DB와 원내 백업에 우선 저장' },
        { title: '한의사 확정', note: '진료지원 제안은 후보로만 유지되고 최종 반영, 수정, 거부 이력은 한의사 계정으로 감사 로그화' },
        { title: '보존 기간 정책', note: '근거문서와 원본 음성은 원내 정책에 따라 보존 기간, 접근 권한, 폐기 로그를 분리 관리' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const queryPanel = new URLSearchParams(window.location.search).get('panel');
        if (queryPanel && this.panels.some((item: any) => item.key === queryPanel)) {
            this.activePanel = queryPanel;
        }
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("overview");
        if (code === 401) {
            window.location.replace("/access");
            return;
        }
        if (code === 200) {
            this.stats = data.stats || this.stats;
            this.summary = data.summary || this.summary;
            this.finalEvidenceId = this.summary.evidence_id || this.finalEvidenceId;
        }

        this.loading = false;
        await this.service.render();
    }

    public pendingSafetyCount() {
        return this.checklist.filter((item: any) => item.required && !item.checked).length;
    }

    public pendingSafetyItems() {
        return this.checklist.filter((item: any) => item.required && !item.checked);
    }

    public completionRate() {
        const done = this.checklist.filter((item: any) => item.checked).length;
        return Math.round((done / this.checklist.length) * 100);
    }

    public chartCompletionRate() {
        const required = this.chartFields.filter((item: any) => item.required);
        const done = required.filter((item: any) => item.status === '확인됨' || item.status === '부인' || item.status === '일부 확인').length;
        return Math.round((done / required.length) * 100);
    }

    public questionnaireScoreRows() {
        return this.questionnaireScoreItems.map((item: any) => {
            const field = this.chartFields.find((chart: any) => chart.label === item.field);
            const status = field ? field.status : '대기';
            const active = status === '확인됨' || status === '일부 확인' || status === '부인';
            return {
                ...item,
                status,
                active,
                percentile: Math.round((item.score / item.max) * 100)
            };
        });
    }

    public questionnaireInputCount() {
        return this.questionnaireScoreRows().filter((item: any) => item.active).length;
    }

    public questionnaireTotalScore() {
        return this.questionnaireScoreRows()
            .filter((item: any) => item.active)
            .reduce((sum: number, item: any) => sum + item.score, 0);
    }

    public questionnaireMaxScore() {
        return this.questionnaireScoreItems.reduce((sum: number, item: any) => sum + item.max, 0);
    }

    public questionnaireZScore() {
        const sd = this.distributionReference.sd || 1;
        return (this.questionnaireTotalScore() - this.distributionReference.mean) / sd;
    }

    public questionnaireZScoreLabel() {
        const value = this.questionnaireZScore();
        return `${value >= 0 ? '+' : ''}${value.toFixed(2)}`;
    }

    public questionnairePercentile() {
        return this.clamp(Math.round(this.normalCdf(this.questionnaireZScore()) * 100), 1, 99);
    }

    public distributionMarkerX() {
        const z = this.clamp(this.questionnaireZScore(), -3, 3);
        return Math.round(32 + ((z + 3) / 6) * 256);
    }

    public distributionFillWidth() {
        return Math.max(0, this.distributionMarkerX() - 32);
    }

    public distributionBand() {
        const percentile = this.questionnairePercentile();
        if (percentile >= 85) return '상위권';
        if (percentile >= 60) return '평균 이상';
        if (percentile >= 35) return '평균권';
        return '낮은 편';
    }

    public normalCdf(z: number) {
        return 0.5 * (1 + this.erf(z / Math.sqrt(2)));
    }

    public erf(value: number) {
        const sign = value < 0 ? -1 : 1;
        const x = Math.abs(value);
        const a1 = 0.254829592;
        const a2 = -0.284496736;
        const a3 = 1.421413741;
        const a4 = -1.453152027;
        const a5 = 1.061405429;
        const p = 0.3275911;
        const t = 1 / (1 + p * x);
        const y = 1 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);
        return sign * y;
    }

    public clamp(value: number, min: number, max: number) {
        return Math.min(max, Math.max(min, value));
    }

    public intakeCompletionRate() {
        const done = this.patientQuestions.filter((item: any) => item.answered).length;
        return Math.round((done / this.patientQuestions.length) * 100);
    }

    public koreanMedicineVitalCompletionRate() {
        const done = this.koreanMedicineVitals.filter((item: any) => item.status === '확인됨' || item.status === '질문함' || item.status === '일부 확인').length;
        return Math.round((done / this.koreanMedicineVitals.length) * 100);
    }

    public activePanelLabel() {
        const panel = this.panels.find((item: any) => item.key === this.activePanel);
        return panel ? panel.label : '진료';
    }

    public async setPanel(panel: string) {
        if (!this.panels.some((item: any) => item.key === panel)) panel = 'intake';
        this.activePanel = panel;
        window.history.replaceState({}, "", `/dashboard?panel=${panel}`);
        await this.service.render();
    }

    public async openDetail(panel: string) {
        this.detailPanel = panel;
        await this.service.render();
    }

    public async closeDetail() {
        this.detailPanel = null;
        await this.service.render();
    }

    public detailTitle() {
        const map: any = {
            complaints: '표준 주소증 및 문진 템플릿',
            stt: '음성인식 후보 및 한의학 용어 보정',
            xai: '판단 근거',
            differential: '감별진단 및 위험 신호',
            advanced: '필요 시 추가 분석',
            rewrite: '수정 이력 및 이전 초안',
            architecture: '저장 및 분석 구조',
            structured: '구조화 기록 및 연동 미리보기',
            quantitative: '지표 및 재진 추적',
            governance: '보안 및 보존 정책',
            prescription: '처방 후보, 금기, 약재 가감',
            applyGate: '최종 반영 전 안전 확인'
        };
        return map[this.detailPanel || ''] || '상세 정보';
    }

    public quantitativeSignalValue(item: any) {
        if (item.label === '차트 확인률') return `${this.chartCompletionRate()}%`;
        if (item.label === '표준 백분위') return `${this.questionnairePercentile()}p`;
        return item.value;
    }

    public async togglePatientQuestion(item: any) {
        item.answered = !item.answered;
        item.answer = item.answered && !item.answer ? '진료실 확인 예정' : item.answer;
        this.auditLogs.unshift({ time: '10:02:58', type: '예진', text: `${item.clinical} 문진 상태를 ${item.answered ? '확인' : '미확인'}으로 변경` });
        await this.service.render();
    }

    public async toggleChartField(field: any) {
        if (field.risk) {
            const unresolved = field.status === '미확인';
            field.status = unresolved ? '부인' : '미확인';
            field.value = unresolved ? '부인' : '진료실 재확인';
        } else {
            const active = field.status === '확인됨' || field.status === '일부 확인';
            field.status = active ? '대기' : '확인됨';
            if (!active && field.value === '입력 대기') field.value = '진료실 확인';
        }

        const checklistItem = this.checklist.find((item: any) => item.label === field.label);
        if (checklistItem) {
            checklistItem.checked = field.status === '확인됨' || field.status === '부인';
            checklistItem.status = field.status;
        }

        const pipelineItem = this.aiPipeline.find((item: any) => item.step === '표준 차트 매핑');
        if (pipelineItem) {
            pipelineItem.status = '반영됨';
            pipelineItem.progress = this.chartCompletionRate();
            pipelineItem.output = `문진 ${this.questionnaireInputCount()}개 반영, 표준분포 ${this.questionnairePercentile()}p`;
        }

        this.auditLogs.unshift({
            time: this.transcriptTime(),
            type: '문진표',
            text: `${field.label} ${field.status} 처리, 표준분포 ${this.questionnairePercentile()}백분위`
        });
        await this.service.render();
    }

    public async toggleHandoff(item: any) {
        item.done = !item.done;
        await this.service.render();
    }

    public async toggleChecklist(item: any) {
        item.checked = !item.checked;
        item.status = item.checked ? '확인됨' : '미확인';
        const chartItem = this.chartFields.find((field: any) => field.label === item.label);
        if (chartItem) chartItem.status = item.status;
        const pipelineItem = this.aiPipeline.find((pipeline: any) => pipeline.step === '표준 차트 매핑');
        if (pipelineItem) {
            pipelineItem.status = '반영됨';
            pipelineItem.progress = this.chartCompletionRate();
            pipelineItem.output = `문진 ${this.questionnaireInputCount()}개 반영, 표준분포 ${this.questionnairePercentile()}p`;
        }
        await this.service.render();
    }

    public speakerInitial(line: any) {
        if (line.speaker === '한의사') return '의';
        if (line.speaker === '환자') return '환';
        return '기';
    }

    public transcriptTime() {
        const now = new Date();
        const pad = (value: number) => value.toString().padStart(2, '0');
        return `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    }

    public async useDialogueSuggestion(text: string) {
        this.dialogueDraft = text;
        await this.service.render();
    }

    public async useKoreanVitalQuestion(item: any) {
        this.activeVitalQuestion = item;
        this.dialogueDraft = item.question;
        item.status = item.status === '확인됨' ? item.status : '질문 예정';
        this.auditLogs.unshift({
            time: this.transcriptTime(),
            type: '한의 생체지표',
            text: `${item.label} 문진 질문을 대화 입력에 준비`
        });
        await this.service.render();
    }

    public async sendDialogueMessage(speaker: string = '한의사') {
        const text = (this.dialogueDraft || '').trim();
        if (!text) return;
        const time = this.transcriptTime();
        const vitalQuestion = speaker === '한의사' ? this.activeVitalQuestion : null;
        const tag = vitalQuestion ? vitalQuestion.label : (speaker === '한의사' ? '진료실 입력' : '환자 발화');
        this.transcript.push({ time, speaker, text, tag });
        this.voiceSegments.unshift({
            time,
            speaker,
            raw: text.replace(/[.?!]/g, ''),
            corrected: text,
            confidence: speaker === '한의사' ? 98 : 92,
            status: '반영됨',
            mapped: vitalQuestion ? `${vitalQuestion.label} 생체지표 문진` : (speaker === '한의사' ? '한의사 확인 발화' : '진료실 입력 기반 구조화')
        });
        if (vitalQuestion) {
            vitalQuestion.status = '질문함';
            vitalQuestion.value = '환자 답변 대기';
            this.activeVitalQuestion = null;
            const standardVital = this.standardQuestions.find((item: any) => item.category === '한의 생체지표');
            if (standardVital) standardVital.status = `${this.koreanMedicineVitalCompletionRate()}% 진행`;
        }
        this.voiceStatus[1].note = `최근 발화: ${speaker}`;
        this.voiceStatus[2].note = `${time} 원문 저장`;
        this.auditLogs.unshift({ time, type: '대화', text: `${speaker} 발화가 대화창과 구조화 기록에 추가됨` });
        this.dialogueDraft = '';
        await this.runAiInferenceDemo(false);
        await this.service.render();
    }

    public async replayVoiceDemo() {
        const time = this.transcriptTime();
        const text = '체중은 줄지 않았고 검은 변도 없었어요. 스트레스 받으면 트림이 더 늘어요.';
        this.voiceDemoRunning = true;
        this.transcript.push({ time, speaker: '환자', text, tag: '실시간 음성인식' });
        this.voiceSegments.unshift({
            time,
            speaker: '환자',
            raw: '체중은 줄지 않았고 검은 변도 없었어요 스트레스 받으면 트림이 더 늘어요',
            corrected: text,
            confidence: 93,
            status: '반영됨',
            mapped: '체중감소 부인 / 흑변 부인 / 스트레스 악화'
        });
        this.voiceStatus[1].note = '최근 발화: 환자';
        this.voiceStatus[2].note = `${time} 원문 저장`;

        const weightLoss = this.checklist.find((item: any) => item.label === '체중감소');
        if (weightLoss) {
            weightLoss.checked = true;
            weightLoss.status = '부인';
        }
        const bleeding = this.checklist.find((item: any) => item.label === '흑변/토혈/빈혈');
        if (bleeding) {
            bleeding.checked = true;
            bleeding.status = '부인';
        }
        this.chartFields.forEach((field: any) => {
            if (field.label === '체중감소') {
                field.value = '부인';
                field.status = '부인';
            }
            if (field.label === '흑변/토혈/빈혈') {
                field.value = '부인';
                field.status = '부인';
            }
            if (field.label === '스트레스/식습관') {
                field.value = '스트레스 시 트림 증가';
                field.status = '확인됨';
            }
        });

        if (!this.soap.S.includes('체중감소와 흑변은 부인')) {
            this.soap.S = `${this.soap.S} 체중감소와 흑변은 부인하며 스트레스 시 트림 증가.`;
        }
        if (!this.soap.A.includes('주요 위험 신호는 일부 배제')) {
            this.soap.A = `${this.soap.A} 주요 위험 신호는 일부 배제됨.`;
        }
        this.auditLogs.unshift({ time, type: '음성인식', text: '환자 발화가 소화불량 표준 차트, 위험 신호, SOAP 초안에 반영됨' });
        await this.runAiInferenceDemo(false);
        await this.service.render();
    }

    public async runAiInferenceDemo(render: boolean = true) {
        this.aiPipeline.forEach((item: any) => {
            if (item.step === '표준 차트 매핑') {
                item.status = '반영됨';
                item.progress = this.chartCompletionRate();
                item.output = `소화불량 필수 차트 ${this.chartCompletionRate()}% 확인, 위험 신호 부인 항목 반영`;
            }
            if (item.step === '검진 지표 비교') {
                item.status = '완료';
                item.progress = 100;
                item.output = 'BMI, 혈압, 공복혈당 경계 지표를 식습관 상담 참고값으로 유지';
            }
            if (item.step === 'SOAP 초안 생성') {
                item.status = this.aiWritingPaused ? '대기' : '생성됨';
                item.progress = this.aiWritingPaused ? 62 : 100;
                item.output = this.aiWritingPaused ? '한의사 직접 수정 중으로 자동 갱신 대기' : '최신 발화와 차트 항목 기준으로 S/O/A/P 갱신';
            }
        });
        this.aiDraftSignals[0].value = this.aiWritingPaused ? '수정 우선' : '최신 반영';
        this.aiDraftSignals[1].value = this.activePattern;
        this.aiDraftSignals[2].value = '안전 확인';
        this.auditLogs.unshift({ time: this.transcriptTime(), type: 'AI 추론', text: '소화불량 주소증, 표준 차트, 검진 지표, 변증 후보를 재계산' });
        if (render) await this.service.render();
    }

    public async selectPattern(candidate: any) {
        const previousPattern = this.activePattern;
        this.patternCandidates.forEach((item: any) => item.selected = false);
        candidate.rejected = false;
        candidate.selected = true;
        this.activePattern = candidate.name;
        this.rewriteSoap(candidate.name, previousPattern);
        this.rewriteHistory.unshift({ time: '10:04:45', action: '한의사 선택', text: `${candidate.name} 중심으로 SOAP/처방 초안을 재구성` });
        this.auditLogs.unshift({ time: '10:04:45', type: '한의사 조정', text: `${candidate.name} 후보 채택` });
        await this.service.render();
    }

    public async promotePattern(candidate: any) {
        await this.movePattern(candidate, -1);
    }

    public async movePattern(candidate: any, direction: number) {
        const index = this.patternCandidates.indexOf(candidate);
        const next = index + direction;
        if (next < 0 || next >= this.patternCandidates.length) {
            await this.selectPattern(candidate);
            return;
        }
        const previous = this.patternCandidates[next];
        this.patternCandidates[next] = candidate;
        this.patternCandidates[index] = previous;
        this.patternCandidates.forEach((item: any, i: number) => item.rank = i + 1);
        this.rewriteHistory.unshift({ time: '10:04:46', action: '순위 변경', text: `${candidate.name} 후보를 ${candidate.rank}순위로 조정` });
        await this.selectPattern(candidate);
    }

    public startDrag(candidate: any) {
        this.draggedPattern = candidate;
    }

    public allowDrop(event: any) {
        event.preventDefault();
    }

    public async dropPattern(target: any) {
        if (!this.draggedPattern || this.draggedPattern === target) return;
        const from = this.patternCandidates.indexOf(this.draggedPattern);
        const to = this.patternCandidates.indexOf(target);
        this.patternCandidates.splice(from, 1);
        this.patternCandidates.splice(to, 0, this.draggedPattern);
        this.patternCandidates.forEach((item: any, i: number) => item.rank = i + 1);
        this.rewriteHistory.unshift({ time: '10:04:47', action: '순위 조정', text: `${this.draggedPattern.name} 후보를 ${this.draggedPattern.rank}순위로 이동` });
        await this.selectPattern(this.draggedPattern);
        this.draggedPattern = null;
    }

    public async rejectPattern(candidate: any) {
        candidate.rejected = true;
        candidate.selected = false;
        this.rewriteHistory.unshift({ time: '10:04:48', action: '한의사 거부', text: `${candidate.name} 후보를 현재 판단에서 제외하고 이전 초안 이력으로 보존` });
        this.auditLogs.unshift({ time: '10:04:48', type: '거부', text: `${candidate.name} 후보 거부` });
        const next = this.patternCandidates.find((item: any) => !item.rejected);
        if (next) await this.selectPattern(next);
        await this.service.render();
    }

    public async restoreGhostDraft(item: any) {
        this.soap.A = item.A;
        this.soap.P = item.P;
        this.rewriteHistory.unshift({ time: '10:04:52', action: '이전 초안 복원', text: `${item.pattern} 초안을 Assessment/Plan에 복원` });
        await this.service.render();
    }

    public rewriteSoap(pattern: string, previousPattern: string = this.activePattern) {
        if (this.aiWritingPaused) return;
        if (pattern === '간위불화형 소화불량') {
            this.ghostDrafts.unshift({ pattern: previousPattern, keptAt: '09:44:45', reason: '간위불화 중심 재작성 전 기존 초안 보존', A: this.soap.A, P: this.soap.P });
            this.soap.A = '소화불량. 스트레스 악화, 명치 답답함, 트림 증가를 근거로 간위불화형 소화불량을 우선 고려. 조기포만감과 식사량 감소가 있어 비위기허도 병행 감별합니다.';
            this.soap.P = '소간이기·화위 중심 치료 방향을 우선 검토하고, 식사량과 수면/긴장도 변화를 추적. 체중감소와 흑변 등 위험 신호 확인 후 최종 반영합니다.';
            this.prescription[0].status = '감별';
            this.prescription[1].status = '1순위';
            this.formulaCandidates.forEach((item: any, index: number) => item.selected = index === 1);
            return;
        }
        if (pattern === '담습중조형 소화불량') {
            this.ghostDrafts.unshift({ pattern: previousPattern, keptAt: '09:44:45', reason: '담습중조 감별 재작성 전 기존 초안 보존', A: this.soap.A, P: this.soap.P });
            this.soap.A = '소화불량. 더부룩함과 무거운 느낌, BMI 경도 증가를 참고하여 담습중조형 가능성을 감별합니다. 현재 정보만으로 단정하지 않고 식습관 및 설태 소견을 추가 확인합니다.';
            this.soap.P = '화담제습 보조 방향은 설태, 대변, 식체감 확인 후 검토. 기본 식사 기록과 위험 신호 확인을 병행합니다.';
            this.prescription[0].status = '감별';
            this.prescription[1].status = '감별';
            this.formulaCandidates.forEach((item: any, index: number) => item.selected = index === 2);
            return;
        }
        this.soap.A = '소화불량. 기능성 소화불량 양상 우선 고려. 비위기허형 소화불량을 1순위로 보며, 스트레스 악화와 명치 답답함으로 간위불화 감별 필요. 체중감소, 흑변/토혈 등 위험 신호 최종 확인 필요.';
        this.soap.P = '식사량과 식후 증상 기록을 안내하고, 건비익기·화위 중심 치료 방향을 검토. 체중감소, 흑변, 진행성 연하곤란을 확인한 뒤 처방 후보와 생활지도를 최종 확정.';
        this.prescription[0].status = '1순위';
        this.prescription[1].status = '감별';
        this.formulaCandidates.forEach((item: any, index: number) => item.selected = index === 0);
    }

    public async toggleAiWriting() {
        this.aiWritingPaused = !this.aiWritingPaused;
        await this.service.render();
    }

    public async pauseAiForField(field: string) {
        this.activeSoapField = field;
        this.aiWritingPaused = true;
        this.auditLogs.unshift({ time: '10:04:53', type: 'SOAP', text: `${field} 영역 직접 수정으로 자동작성 일시정지` });
        await this.service.render();
    }

    public async resumeAiForEmpty(field: string) {
        this.activeSoapField = null;
        const content = this.soap[field] || '';
        if (!content.trim()) this.aiWritingPaused = false;
        await this.service.render();
    }

    public async runAnalysis(item: any) {
        item.status = '완료';
        this.auditLogs.unshift({ time: '10:04:50', type: item.name, text: `${item.name} 결과를 근거문서에 연결` });
        await this.service.render();
    }

    public async applyRecord() {
        const pending = this.pendingSafetyCount();
        if (pending > 0) {
            this.detailPanel = 'applyGate';
            await this.service.render();
            return;
        }

        await this.confirmApply();
    }

    public async toggleApplyCheck(item: any) {
        item.done = !item.done;
        await this.service.render();
    }

    public async confirmApply() {
        const pending = this.pendingSafetyCount();
        if (pending > 0 && !this.safetyOverrideReason.trim()) {
            await this.service.modal.show({
                title: '미확인 사유 필요',
                message: '미확인 위험 항목을 남기고 저장하려면 의학적 판단 사유를 기록해야 합니다.',
                cancel: false,
                action: '확인',
                status: 'warning',
                actionBtn: 'warning'
            });
            return;
        }
        this.applyChecklist.forEach((item: any) => item.done = true);
        this.applyStatus = 'saved';
        this.auditLogs.unshift({ time: '10:05:00', type: '최종 반영', text: `${this.finalEvidenceId} SOAP/처방 확정 및 로컬 DB 저장, 원내 백업 대기` });
        if (this.safetyOverrideReason.trim()) {
            this.auditLogs.unshift({ time: '10:05:00', type: '사유', text: `미확인 안전 항목 저장 사유: ${this.safetyOverrideReason}` });
        }
        this.detailPanel = null;
        await this.service.modal.success('최종 SOAP와 처방 초안이 근거문서와 함께 확정되었습니다.');
        await this.service.render();
    }

    public toneClass(tone: string) {
        const map: any = {
            emerald: 'border-emerald-200 bg-emerald-50 text-emerald-800',
            sky: 'border-sky-200 bg-sky-50 text-sky-800',
            rose: 'border-rose-200 bg-rose-50 text-rose-800',
            amber: 'border-amber-200 bg-amber-50 text-amber-800'
        };
        return map[tone] || 'border-zinc-200 bg-zinc-50 text-zinc-800';
    }

    public checklistClass(item: any) {
        if (item.risk && !item.checked) return 'border-rose-200 bg-rose-50 text-rose-800';
        if (item.checked) return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        return 'border-zinc-200 bg-zinc-50 text-zinc-700';
    }

    public statusClass(status: string) {
        if (status === '완료' || status === '저장됨' || status === '확인됨' || status === '부인' || status === '반영됨' || status === '생성됨' || status === '보정됨' || status === '정상' || status === '질문함') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        if (status === '진행' || status === '갱신 중' || status === '일부 확인' || status === '수신 중' || status === '분석 중' || status === '검토 필요' || status === '주의' || status === '질문 예정') return 'border-amber-200 bg-amber-50 text-amber-800';
        if (status === '미확인' || status === '대기') return 'border-rose-200 bg-rose-50 text-rose-800';
        return 'border-zinc-200 bg-zinc-50 text-zinc-700';
    }

    public barWidth(value: number) {
        return `${Math.max(0, Math.min(100, value))}%`;
    }

    public structuredRecordJson() {
        return JSON.stringify({
            session_id: '20260627-001',
            patient_id: this.summary.patient,
            chief_complaint: this.summary.chief,
            secondary_complaint: this.summary.secondary,
            precheck_summary: {
                original: this.precheck.input,
                completed: this.precheck.completed,
                total: this.precheck.total,
                patient_questions: this.patientQuestions
            },
            case_flow: this.caseFlow,
            chart_fields: this.chartFields,
            korean_medicine_vitals: this.koreanMedicineVitals,
            health_screening_metrics: this.screeningMetrics,
            symptom_score_trend: this.symptomScoreTrend,
            realtime_voice_demo: {
                status: this.voiceStatus,
                segments: this.voiceSegments,
                transcript: this.transcript
            },
            ai_inference_demo: this.aiPipeline,
            pattern_candidates: this.patternCandidates.map((item: any) => ({
                name: item.name,
                confidence: item.confidence / 100,
                rank: item.rank,
                selected: item.selected,
                rejected: item.rejected
            })),
            pattern: this.activePattern,
            safety_pending: this.pendingSafetyCount(),
            safety_override_reason: this.safetyOverrideReason || null,
            evidence_id: this.finalEvidenceId,
            apply_status: this.applyStatus,
            doctor_override: this.rewriteHistory[0] || null,
            soap: this.soap,
            prescription: this.prescription,
            storage_targets: this.storageFlow
        }, null, 2);
    }

    public fhirPreviewJson() {
        return JSON.stringify({
            resourceType: 'Bundle',
            type: 'document',
            identifier: { value: this.finalEvidenceId },
            subject: { reference: `Patient/${this.summary.patient}` },
            entry: [
                { resource: { resourceType: 'Composition', title: '한의 진료지원 근거문서' } },
                { resource: { resourceType: 'Observation', code: { text: 'Chief complaint' }, valueString: this.summary.chief } },
                { resource: { resourceType: 'CarePlan', description: this.soap.P } }
            ],
            composition: {
                chiefComplaint: this.summary.chief,
                patternAssessment: this.activePattern,
                safetyPending: this.pendingSafetyCount()
            }
        }, null, 2);
    }
}

export default PageDashboardComponent;